var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline"
    },
    height: "1.5em",
    viewBox: "0 -960 960 960",
    width: "1.5em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.69-100q-23.53 0-40.61-17.08T180-157.69v-644.62q0-23.53 17.08-40.61T237.69-860h484.62q23.53 0 40.61 17.08T780-802.31v644.62q0 23.53-17.08 40.61T722.31-100H237.69Zm82.49-591.92q11.67 0 19.78-8.3 8.12-8.3 8.12-19.96 0-11.67-8.3-19.78-8.3-8.12-19.96-8.12-11.67 0-19.78 8.3-8.12 8.3-8.12 19.96 0 11.67 8.3 19.78 8.3 8.12 19.96 8.12Zm120 0q11.67 0 19.78-8.3 8.12-8.3 8.12-19.96 0-11.67-8.3-19.78-8.3-8.12-19.96-8.12-11.67 0-19.78 8.3-8.12 8.3-8.12 19.96 0 11.67 8.3 19.78 8.3 8.12 19.96 8.12ZM480-257.31q55.92 0 95.31-37.95 39.38-37.94 39.38-92.59 0-25.61-9.54-49.65T576.77-480L480-576.77l-93.35 93.36q-18.65 19.03-30.5 43.68-11.84 24.65-10.84 51.73 1.48 54.73 40.61 92.71 39.12 37.98 94.08 37.98Zm.14-42.38q-37.22 0-63.33-25.7-26.12-25.7-26.12-62.79 0-17.97 7.62-34.55 7.61-16.58 21-29.35L480-512.15l65.08 64.46q11.77 11.38 18 26.79 6.23 15.4 6.23 32.8 0 37.06-25.98 62.73-25.97 25.68-63.19 25.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.1a14a36a08f6f291a763e4dccb318e19.svg";
export { ForwardRef as ReactComponent };